module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "galley"
  }, [_c('div', {
    staticClass: "body Part"
  }, [_c('p', {
    attrs: {
      "id": "rw-p_122093-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('div', {
    staticClass: "title-block",
    attrs: {
      "id": "rw-title-block_122093-00001"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('h1', [_c('a', {
    attrs: {
      "id": "pb-rw_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/9781847676931_toc"
    }
  }, [_vm._v("SIX MONTHS EARLIER …")])])]), _vm._v(" "), _c('p', {
    staticClass: "fp",
    attrs: {
      "id": "rw-p_122093-00002"
    }
  }, [_c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  })])]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  })]), _c('a', {
    attrs: {
      "id": "pb-rw_8"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-16304d1c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781847676931_part_01.vue
// module id = 78
// module chunks = 0